module.exports = __webpack_public_path__ + "static/img/20200227.ce1504e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/qiye/20200227.png
// module id = iG2M
// module chunks = 1